import React, { useState } from "react";
import { Modal, Input, Form, Button, Select, notification, Row, Col } from "antd";
import StockApi from "../common/Apis/StockApi";
import StockAdjustmentLogApi from "../common/Apis/StockAdjustmentLogApi";
import dayjs from "dayjs";

const AdjustStockModal = ({ visible, onClose, stockDetails, stockId, productPayload, listStockData = [], onAdjustSuccess }) => {
    const [loading, setLoading] = useState(false);
    const [form] = Form.useForm();
    const [selectedUOM, setSelectedUOM] = useState("UOM1");
    const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));

    console.log(`this is ${stockId}`)

    const stockFromList = listStockData?.find((item) => item.id === stockId) || stockDetails || {};
    const product = productPayload || stockFromList?.productDTO || stockFromList?.productDTOs?.[0] || {};
    const productName = product?.productName || product?.name || stockFromList?.productDTOs?.[0]?.productName || stockDetails?.productDTOs?.[0]?.productName || "";
    const uomOptions = [
        { label: product?.unitUomOne || product?.uom1 || product?.primaryUnit || "UOM1", value: "UOM1" },
        { label: product?.unitUomTwo || product?.uom2 || product?.secondaryUnit || "UOM2", value: "UOM2" },
    ];

    function convertToUnixTimestamp(dateString) {
        const parts = dateString.split("/");
        const day = parseInt(parts[0], 10);
        const month = parseInt(parts[1], 10) - 1;
        const year = parseInt(parts[2], 10);

        const unixTimestamp = Date.UTC(year, month, day);
        return unixTimestamp;
    }

    const handleClose = () => {
        form.resetFields();
        setSelectedUOM("UOM1");
        setLoading(false);
        onClose();
    };

    const handleSubmit = (values) => {
        setLoading(true);

        const activeStock = stockFromList || stockDetails || {};
        const currentQuantity = parseFloat(activeStock?.unitOfMeasurement1);

        let adjustedQuantity = parseFloat(values.quantity);

        // Convert to base quantity if UOM1 is selected
        if (selectedUOM === "UOM1") {
            adjustedQuantity = adjustedQuantity * (product?.unitOfMeasurement2 || 1);
        }

        if (values.reason === "increase") {
            adjustedQuantity = currentQuantity + parseFloat(adjustedQuantity);
        } else if (values.reason === "decrease") {
            adjustedQuantity = currentQuantity - parseFloat(adjustedQuantity);
        } else {
            adjustedQuantity = parseFloat(adjustedQuantity);
        }

            if(adjustedQuantity > activeStock?.initQuantity) {
            notification.error({
                message: "Validation Error",
                description: "Quantity can't exceed the initial stock.",
                });
            return;
        }


        const stockAdjustAffectedDate = Date.now();
        console.log("adjusted qty", adjustedQuantity);
        console.log("stock:", activeStock);

        // let formData = JSON.stringify({
        //     unitOfMeasurement1: adjustedQuantity,
        //     // unitOfMeasurement2: data.unitOfMeasurement2,
        //     version: stockDetails?.version,
        //     invoiceNumber: stockDetails.invoiceNumber,
        //     //   openUBD: convertToUnixTimestamp( dayjs(data.OUBD).format("DD/MM/YYYY")),
        //     // expiryDate: convertToUnixTimestamp(stockDetails?.modifiedDate),
        //     expiryDate: stockDetails?.expiryDate,
        //     batchCode: stockDetails.batchCode,
        //     unit: stockDetails?.unit,
        //     productDTO: {
        //         id: stockDetails.productDTOs?.[0]?.id,
        //         // supplierId: stockDetails.supplierId,
        //         // institutionId: stockDetails.institutionId,
        //     },
        //     productDTOs: [{
        //         id: stockDetails.productDTOs?.[0]?.id,
        //     }],
        //     // allergensDTO: stockDetails?.allergensDTOList,
        //     tenantDTO: {
        //         id: decodedToken?.tenantId,
        //         tenantApiKey: decodedToken?.tenantApiKey,
        //     },
        //     storageId: stockDetails?.stockStorageViewDTO?.storageId,
        //     initQuantity: initStockQty,
        //     reasonForChange: values.reason,
        //     affectedUseByDate: stockDetails?.expiryDate,
        // });


         let formData = JSON.stringify({
            stockId: stockId,
            batchCode: activeStock?.batchCode,
            previousQuantity: activeStock?.unitOfMeasurement1,
            initQuantity: activeStock?.initQuantity,
            newQuantity: adjustedQuantity,
            comment: values.reason,
            adjustedBy: productPayload?.subTenantDTO?.subTenantName || decodedToken?.subTenantName || decodedToken?.name || "System",
            adjustedTimestamp: Date.now(),
            tenantDTO: {
                id: productPayload?.tenantDTO?.id || decodedToken?.tenantId,
                tenantApiKey: decodedToken?.tenantApiKey,
            },
            subTenantDTO: {
                id: productPayload?.subTenantDTO?.id || decodedToken?.subTenantId,
            },
            institutionDTO: {
                id: productPayload?.institutionDTO?.id || decodedToken?.institutionId,
            },
            reason: values.reason,
            affectedDate: activeStock?.expiryDate || stockAdjustAffectedDate,
        });

        StockAdjustmentLogApi.CreateStockAdjustmentLog(formData)
            .then((response) => {
                notification.open({
                    message: <span style={{ fontWeight: "bold" }}>Updated</span>,
                    description: "Updated Successfully",
                    closeIcon: false,
                    duration: 3,
                    style: {
                        backgroundColor: "#b3ffb3",
                        color: "green",
                    },
                });
                // setTimeout(() => {
                //     window.location.reload();
                // }, 500);
                setSelectedUOM("UOM1");
                onAdjustSuccess?.();
                onClose();
            })
            .catch((err) => {
                console.log(err);
                notification.error({ message: err?.apiError?.message || "Error adjusting stock" });
                // Error Notification
                // if (err.apiError.status) {
                //   notification.open({
                //     message: (
                //       <span style={{ fontWeight: "bold" }}>{err.apiError.status}</span>
                //     ),
                //     description: err.apiError.message,
                //     closeIcon: false,
                //     duration: 3,
                //     style: {
                //       backgroundColor: "#fff2f0",
                //       color: "red",
                //     },
                //   });
                // }
            }).finally(() => setLoading(false));;

        // let formData = JSON.stringify({
        //     id: stockDetails?.id,
        //     batchCode: stockDetails?.batchCode,
        //     // initQuantity: stockDetails?.initQuantity,
        //     // unitOfMeasurement1: adjustedQuantity,
        //     initQuantity: adjustedQuantity,
        //     previousQuantity: stockDetails?.unitOfMeasurement1,
        //     reasonForChange: values.reason,
        //     storageId: stockDetails?.storageId,
        //     affectedUseByDate: convertToUnixTimestamp(stockAdjustAffectedDate),
        //     tenantDTO: {
        //         id: decodedToken?.tenantId,
        //         tenantApiKey: decodedToken?.tenantApiKey,
        //     },
        // });

        // const payload = {
        //     productId,
        //     adjustmentReason: values.reason.trim(),
        //     adjustedQuantity,
        // };

        // StockApi.AdjustStock(stockDetails?.id, formData)
        //     .then(() => {
        //         // notification.success({ message: "Stock adjusted successfully" });
        //         // form.resetFields();
        //         notification.open({
        //             // message: <span style={{ fontWeight: "bold" }}>Created</span>,
        //             description: "stock adjusted Successfully",
        //             closeIcon: false,
        //             duration: 3,
        //             style: {
        //                 backgroundColor: "#b3ffb3",
        //                 color: "green",
        //             },
        //         });
        //         setTimeout(() => {
        //             window.location.reload();
        //         }, 500);
        //         setSelectedUOM("UOM1");
        //         onClose();
        //     })
        //     .catch((err) => {
        //         notification.error({ message: err?.apiError?.message || "Error adjusting stock" });
        //     })
        //     .finally(() => setLoading(false));
    };

    return (
        <Modal
            open={visible}
            title={`Adjust Stock - ${productName}`}
            onCancel={handleClose}
            footer={null}
            destroyOnClose
            afterClose={() => {
                form.resetFields();
                setSelectedUOM("UOM1");
                setLoading(false);
            }}
        >
            <Form form={form} layout="vertical" onFinish={handleSubmit}>
                <Form.Item label="Adjusted Quantity & Unit" required>
                    <Row gutter={8}>
                        <Col flex="auto">
                            <Form.Item
                                name="quantity"
                                noStyle
                                rules={[
                                    { required: true, message: "Please enter quantity" },
                                    {
                                        validator: (_, value) =>
                                            value && parseFloat(value) >= 0
                                                ? Promise.resolve()
                                                : Promise.reject(new Error("Quantity must be 0 or greater")),
                                    },
                                ]}
                            >
                                <Input type="number" min={0} step="0.01" placeholder="Enter quantity" />
                            </Form.Item>
                        </Col>
                        <Col flex="120px">
                            <Form.Item
                                name="unit"
                                noStyle
                                initialValue="UOM1"
                                rules={[{ required: true, message: "Please select unit" }]}
                            >
                                <Select options={uomOptions} onChange={(value) => setSelectedUOM(value)} />
                            </Form.Item>
                        </Col>
                    </Row>
                </Form.Item>

                <Form.Item
                    label="Reason"
                    name="reason"
                    rules={[{ required: true, message: "Please select a reason" }]} // Required validation
                >
                    <Select placeholder="Select reason for adjustment">
                        <Select.Option value="increase">Increase Stock</Select.Option>
                        <Select.Option value="decrease">Decrease Stock</Select.Option>
                        <Select.Option value="recount">Recount correction</Select.Option>
                    </Select>
                </Form.Item>

                <Form.Item>
                    <div className="d-flex justify-content-between pt-4" style={{ gap: "10px" }}>
                        <Button
                            type="primary"
                            htmlType="submit"
                            disabled={loading}
                            style={{ flex: 1, height: 40, borderRadius: 6 }}
                        >
                            Adjust Stock
                        </Button>

                        <Button onClick={onClose} style={{ flex: 1, height: 40, borderRadius: 6 }}>
                            Cancel
                        </Button>
                    </div>
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default AdjustStockModal;
